import "../css/ImageContainer.css";
import { ChevronDown } from "lucide-react";
import { motion } from "framer-motion";

function ImageContainer(props) {

  return (
    <div className="block-imagecontainer relative overflow-hidden">
      
      {/* Imagen con animación */}
      <motion.div
        className="imagecontainer-overlay"
        initial={{ scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      >
        <img
          src={props.src}
          alt="utpl"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Overlay oscuro suave */}
      <motion.div
        className="absolute inset-0 bg-black/40"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />

      {/* Contenido */}
      <motion.div
        className="contentcontainer relative z-10 flex items-center justify-center h-full text-white"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.8 }}
      >
        <div className="text-center max-w-2xl px-4">
          {props.content}
        </div>
      </motion.div>

      {/* Indicador */}
      <motion.div
        className="scroll-indicator "
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.8 }}
      >
        <span className="text-sm mb-2">
          Desliza para continuar con tu experiencia
        </span>

        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{
            repeat: Infinity,
            duration: 1.5,
            ease: "easeInOut",
          }}
        >
          <ChevronDown size={28} />
        </motion.div>
      </motion.div>

    </div>
  );
}

export default ImageContainer;